var module = angular.module('octopusApp.infrastructure')

    .run(ConfigureRedirectOn401)

    .run(ConfigureRedirectWhenNoUser);

function ConfigureRedirectWhenNoUser($rootScope, $location, $state, octopusAuthenticator, octopusLog, octopusClient) {
        // Some global properties for the current page
        $rootScope.isAuthenticated = octopusAuthenticator.currentUser() || false;
        $rootScope.currentUser = octopusAuthenticator.currentUser();
        $rootScope.redirectAfterFormsLoginTo = null;
        $rootScope.redirectAfterExternalLoginTo = octopusClient.uiRelativeRootPath($location);

        function stateRedirect(toState, toParams) {
            var redirect = toState.redirectTo;
            if (redirect) {
                if (angular.isFunction(redirect)) {
                    redirect.call($state, toState, toParams);
                } else {
                    $state.go(redirect);
                }
                return true;
            }
        }

        function subRouteRedirect(toState, toParams) {
            var redirect = toState.defaultSubRoute;
            if (redirect) {
                $state.go(redirect, toParams, { location: false });
                return true;
            }
        }

        $rootScope.$on('$stateChangeSuccess', function(){
            $rootScope.isAuthenticated = octopusAuthenticator.currentUser()  || false;
            $rootScope.currentUser = octopusAuthenticator.currentUser();
        });

        // When the user changes navigation, make sure they are logged in
        $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
            if (subRouteRedirect(toState, toParams)){
                event.preventDefault();
                return;
            }

            if (stateRedirect(toState, toParams)) {
                event.preventDefault();
                return;
            }

            if (toState.name === 'app.not-found') {
                return;
            }

            if (octopusAuthenticator.currentUser() !== null) {
                $rootScope.redirectAfterFormsLoginTo = null;
                $rootScope.redirectAfterExternalLoginTo = octopusClient.uiRelativeRootPath($location);
                return;
            }


            var isDevelopmentMode = !octopusClient.urlIndicatesNonDevelopmentMode($location.absUrl(), octopusClient.resolve('~/'));
            octopusLog.log('There is no current user.');
            if (isAnonymous(toState)) {
                // Preserve any pre-existing redirection so we follow deep links after signin or registration
                if ($rootScope.redirectAfterFormsLoginTo === null) {
                    // The user refreshed on the signin or register page and we want to redirect to the dashboard afterwards
                    if (isDevelopmentMode) {
                        $rootScope.redirectAfterFormsLoginTo = $location.absUrl().replace($location.path(), '');
                        if ($rootScope.redirectAfterFormsLoginTo.endsWith('#')) {
                            $rootScope.redirectAfterFormsLoginTo += '/';
                        }
                        $rootScope.redirectAfterExternalLoginTo = $rootScope.redirectAfterFormsLoginTo;

                    } else {
                        $rootScope.redirectAfterFormsLoginTo = '/';
                        $rootScope.redirectAfterExternalLoginTo = octopusClient.uiRelativeRootPath($location);
                    }
                }
                octopusLog.log('Sign-in or registration page is allowed, will return to ' + $rootScope.redirectAfterFormsLoginTo);
            } else {
                // This looks like the user has navigated to a deep link but isn't authenticated
                // We need to preserve the original intended route, and redirect to the signin page
                if (isDevelopmentMode) {
                    //$rootScope.redirectAfterFormsLoginTo = $state.href(fromState.name, fromParams, {absolute: true});
                    $rootScope.redirectAfterFormsLoginTo = $location.absUrl().replace($location.path(), '') + $state.href(toState.name, toParams).replace('#', '');
                    $rootScope.redirectAfterExternalLoginTo = $rootScope.redirectAfterFormsLoginTo;
                } else {
                    $rootScope.redirectAfterFormsLoginTo = $state.href(toState.name, toParams).replace('#', ''); //$location.path(); // e.g: /users/sign-out"
                    $rootScope.redirectAfterExternalLoginTo = octopusClient.urlStripHostAndPort($location);
                }
                octopusLog.log('Redirecting to the sign-in page, will return to ' + $rootScope.redirectAfterFormsLoginTo);

                event.preventDefault();
                $state.go('app.signin');
            }
        });
    }

function ConfigureRedirectOn401($rootScope, $location, octopusLog, octopusAuthenticator, octopusClient, $state) {
    Octopus.Client.Util.ajax.error = function (error) {
        if (error.StatusCode === 401 && !isAnonymous($state.current)) {
            var apiUrl = octopusClient.resolve('~/');
            if (octopusClient.urlIndicatesNonDevelopmentMode($location.absUrl(), apiUrl)) {
                $rootScope.redirectAfterFormsLoginTo = $location.path();
                $rootScope.redirectAfterExternalLoginTo = octopusClient.urlStripHostAndPort($location);
            } else {
                $rootScope.redirectAfterFormsLoginTo = $location.absUrl();
                $rootScope.redirectAfterExternalLoginTo = $rootScope.redirectAfterFormsLoginTo;
            }
            octopusLog.log("Cookie has expired. Redirecting to login page, but will return to " + $rootScope.redirectAfterFormsLoginTo);
            octopusAuthenticator.setCurrentPrincipal(null, null);
            $state.go("app.signin");
        }
    };
}

function isAnonymous(stateName) {
        return (stateName.name.indexOf('app.register') === 0 || stateName.name === 'app.signin');
    }


//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/routing/authentication.js
// module id = 692
// module chunks = 1